import {fetchTemplate} from '@components/Template/templateSlice';
import fetchDesignerBase from './fetchDesignerBase';

export default function fetchTemplateDesigner({
    store, headers, baseUrl, params, options
}) {
    return [
        ...fetchDesignerBase({
            store, headers, baseUrl, params, options
        }),
        store.dispatch(fetchTemplate({
            headers, baseUrl, params, options
        }))
    ];
}
